import { join, dirname } from 'node:path';
import { outputFile, outputDir, removeDir, writeJson } from '@wix/cli-fs';
import { MULTILINGUAL_METADATA_FILENAME } from '@wix/cli-astro-definitions';

export async function saveTranslationFiles(
  translationsDir: string,
  translationsByLanguage: Record<string, Record<string, string>>,
  primaryLanguage: string
) {
  const multilingualDir = dirname(translationsDir);
  await removeDir(multilingualDir);
  await outputDir(translationsDir);

  for (const [locale, translations] of Object.entries(translationsByLanguage)) {
    const filePath = join(translationsDir, `${locale}.json`);
    await outputFile(filePath, JSON.stringify(translations, null, 2));
  }

  const metadataPath = join(multilingualDir, MULTILINGUAL_METADATA_FILENAME);
  await writeJson(
    metadataPath,
    { primaryLanguageCode: primaryLanguage },
    { spaces: 2 }
  );
}
